module.exports = __webpack_public_path__ + "static/media/img21.c3adb08b.JPG";